import { render, staticRenderFns } from "./manageBrand.vue?vue&type=template&id=4b9465c4&"
import script from "./manageBrand.vue?vue&type=script&lang=js&"
export * from "./manageBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports